module.exports = __webpack_public_path__ + "static/img/ddyfz.4206f5c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/audit/ddyfz.png
// module id = H+Hj
// module chunks = 1